import api from '@/axios'
import type {Login, ActivateUser, Token, LoginResponse, ResetPasswordRequest, ForgotPasswordRequest} from '@/types/auth-types'

export const login = async (data: Login): Promise<LoginResponse> => {
  const response = await api.post('/auth/login', data)
  return response.data
}

export const activateUser = async (data: ActivateUser): Promise<ActivateUser> => {
  const response = await api.post('/auth/activate', data)
  return response.data
}

export const refreshToken = async (data: Token): Promise<Token> => {
  const response = await api.post('/auth/refresh-token', data)
  return response.data
}

export const forgotPassword = async (data: ForgotPasswordRequest): Promise<void> => {
  const response = await api.post('/auth/forgot-password', data)
  return response.data
}

export const resetPassword = async (data: ResetPasswordRequest): Promise<void> => {
  const response = await api.post('/auth/reset-password', data)
  return response.data
}